import { ChangeEvent, useCallback } from "react"
import { FilterItemProps, inputClasses } from "../_common"

export function CheckBoxFilter({
    name,
    value,
    handleChange,
}: FilterItemProps<boolean>) {
    const onChange = useCallback(
        (e: ChangeEvent<HTMLInputElement>) => {
            const val = e.currentTarget.checked
            handleChange?.(val)
        },
        [handleChange]
    )
    const checkboxStyle = {
        backgroundColor: value ? '#003673' : '#FFF',
        width: '8px',
        height: '20px',
        cursor: 'pointer',
        margin: 'auto',
        marginTop: '0.75rem',
        border: '2px solid #003673',
    };
    return (
        <input
            type="checkbox"
            name={name}
            id={name}
            className={inputClasses}
            onChange={onChange}
            checked={value}
            style={checkboxStyle}
        />
    )
}
